import React from 'react';
import { WifiOff, RefreshCw } from 'lucide-react';
import { useOffline } from '@/context/offlineContext';
import { syncQueuedInspections } from '@/services/syncService';
import toast from 'react-hot-toast';

export function OfflineBanner() {
  const { isOnline, queueCount, refreshQueueCount } = useOffline();
  const [syncing, setSyncing] = React.useState(false);

  if (isOnline && queueCount === 0) return null;

  async function handleManualSync() {
    setSyncing(true);
    try {
      const { synced, failed } = await syncQueuedInspections();
      if (synced > 0) toast.success(`${synced} inspection${synced > 1 ? 's' : ''} submitted`);
      if (failed > 0) toast.error(`${failed} failed to sync`);
      await refreshQueueCount();
    } finally {
      setSyncing(false);
    }
  }

  return (
    <div className={`flex items-center justify-between px-4 py-2 text-sm font-medium ${
      isOnline ? 'bg-status-warning/10 text-status-warning' : 'bg-status-fail/10 text-status-fail'
    }`}>
      <div className="flex items-center gap-2">
        <WifiOff className="h-4 w-4 shrink-0" />
        {isOnline
          ? `${queueCount} inspection${queueCount > 1 ? 's' : ''} waiting to sync`
          : `Offline — ${queueCount > 0 ? `${queueCount} inspection${queueCount > 1 ? 's' : ''} queued` : 'changes will be saved locally'}`
        }
      </div>
      {isOnline && queueCount > 0 && (
        <button
          onClick={handleManualSync}
          disabled={syncing}
          className="flex items-center gap-1 rounded px-2 py-1 hover:bg-status-warning/10"
        >
          <RefreshCw className={`h-3.5 w-3.5 ${syncing ? 'animate-spin' : ''}`} />
          {syncing ? 'Syncing...' : 'Sync now'}
        </button>
      )}
    </div>
  );
}